// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio--1-8VN6vbcp","dark":"dark--10xxcxl3ZW","light":"light--3MpamiGE2k","disabled":"disabled--2M2HA6aF_-"};